<script>
	import PosterText from 'component/PosterText.svelte'
	import { img_prefix } from 'shared/var'

	export let groups, promo_active

	let active_menu_item
</script>

{#each groups.filter(g => promo_active ? g.enabled_mobile_during_promo : g.enabled_mobile) as g}
	<div class="home_button" class:active="{active_menu_item === g.id}">
		<a href="{g.url}">
			<img src="{img_prefix}/{encodeURI(g.sets.Landscape.pick)}?auto=format,compress&h=260&fit=fill" alt="" />
		</a>
		<div class="screen-overlay-container">
			<div class="screen-overlay">
				<a href="{g.url}" class="text">
					<PosterText>
						{g.name}
					</PosterText>
				</a>
			</div>
		</div>
	</div>
{/each}

<style>
	.home_button {
		position: relative;
	}

	.home_button > a {
		background: #000;
		display: block;
		position: relative;
		padding-bottom: 31%;
		overflow: hidden;
	}

	a {
		-webkit-tap-highlight-color:rgba(0,0,0,0);
		outline:none;
		transition: none;
	}

	img {
		transition: .1s ease-in-out;
		filter: saturate(1.3) brightness(1) contrast(1);
		display: block;
		position: absolute;
		top: 0; right: 0; left: 0;
	}

	.text {
		font-size: 12vw;
	}

	.text :global(.poster_text) {
		text-align: right !important;
	}

	.home_button.active .text {
		position: absolute;
		top: 0;
		left: 1vw;
		white-space: nowrap;
		height: 26vw;
		z-index: 11;
		font-size: 12vw;
	}

	.home_button.active .text :global(.poster_text){
		text-align: left !important;
	}

	.home_button.active a img {
		filter: saturate(1) brightness(2) contrast(1) blur(5px);
		transform: scale(1.1);
	}

	.home_button.active .screen-overlay-container {
		margin: calc(1rem - 31vw) 1rem 1rem;
	}

	.home_button.active .screen-overlay {
		background: #000;
		mix-blend-mode: multiply;
		position: absolute;
		top: 0; right: 0; bottom: 0; left: 0;
	}
</style>
